import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { MsalBroadcastService, MsalGuard, MsalService } from '@azure/msal-angular';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';


import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { WarningPopupComponent } from './components/warning-popup/warning-popup.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';

import { ButtonModule } from 'primeng/button';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GeaLibraryModule } from './gea-library.module';
import { MarkdownModule } from 'ngx-markdown';


@NgModule({
  declarations: [HeaderComponent, SidebarComponent, WarningPopupComponent, ProgressBarComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      }
    }),
    ButtonModule,
    HttpClientModule,
    GeaLibraryModule,
    MarkdownModule.forRoot()

  ], schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    /*   provideAnimationsAsync(),
      providePrimeNG({
        theme: {
          preset: Material,
        },
      }), */
    MsalService,
    MsalGuard,
    MsalBroadcastService,

  ],
  exports: [MarkdownModule, TranslateModule, HeaderComponent, SidebarComponent, FormsModule, ReactiveFormsModule, WarningPopupComponent, ButtonModule, HttpClientModule]
})
export class SharedModule { }
